<template>
  <div class="panel-body">
    <import-data :route="'plano-periodo'" :json_fields="headers" :json_data="planosValidade"></import-data>
    <div class="row">
      <div class="col-md-12">
        <filterable @loading="changeLoading" ref="filter" v-bind="filterable">
          <thead slot="thead">
            <tr>
              <th>{{$t('words.options')}}</th>
              <th>Nome</th>
              <th>Vencimento</th>
              <th>Desconto</th>              
            </tr>
          </thead>
           <tr slot-scope="{item, dropup}">
        <td class="column-options">    
          <div class="btn-group" :class="{'dropup': dropup}">
                <button type="button"  class="btn btn-default btn-sm dropdown-toggle"
                  v-bind:title="$t('words.operations')" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fa fa-bars" aria-hidden="true"></i>
                  <span class="caret"></span>
                </button>
                <div class="dropdown-menu">               
                    <a class="dropdown-item" @click="detailsObject(item)">
                      <i class="fa fa-eye"></i>
                      {{$t('words.details') }}
                    </a>               
                    <router-link class="dropdown-item" :to="{ name: `plano-validadeEdit`, params: { id: item.id}}">
                      <i class="fa fa-pencil"></i>
                      {{$t('words.edit')}}
                    </router-link>               
                    <a class="dropdown-item" @click="deleteData(item.id, item.nome, 'plano-validade')">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                      {{$t('words.delete')}}
                    </a>
                </div>
              </div>
            </td>
            <td>{{item.nome}}</td>
            <td>{{item.vencimento}}</td>
            <td>{{item.desconto}}</td>
             </tr>
        </filterable>
      </div>
    </div>
    <show-data :description="description" :data="objectDetails" :headers="headers"></show-data>
  </div>
</template>

<script>  
  export default {
    data() {
      return {
        filterable: {
          deleted: false,
          model: 'planoValidade',
          options: 'municipios',
          storeAction: 'setPlanoValidade',
          storeName: 'planoValidade.data',
          url: '/api/planos-validade',
          loading: false
        },
        objectDetails: {},
        description: 'nome',
        headers: {
          'Nome': 'nome',
          'Vencimento': 'vencimento',
          'Desconto': 'desconto',
        }
      };
    },
    beforeMount() {
     
     
      
      
           
    },
    computed: {
      planosValidade() {
        return this.$store.state.planoValidade.data;
      }
    },
    watch: {
      $route(data) {
        if (data.name === 'planosValidade') {
          this.prepareComponent();
        }
      }
    }
  };
</script>